import React from 'react';
import ScrollArea from 'react-scrollbar';
import videoImg from '~/assets/images/videoimage.png';
import contentImg from '~/assets/images/content-pic-dummy.jpeg';

const ModuleNine = (props) => {
    const {value, index, length} = props;

    return (
        <div className="videomodule">

            <ScrollArea
                speed={0.8}
                className="modulemodalscroll"
                contentClassName="content"
                horizontal={false}
            >
                <div className="image-content-wrap">
                    <div className="module-content">
                        <div className="d-flex justify-content-between m-b-20">
                            <h3 className="module-content-header">{value?.name}</h3>
                            <span className="module-count">
                    {`${index + 1}`} / {length ? length : ''} Modules
                            </span>
                        </div>
                        <p dangerouslySetInnerHTML={{__html: `${value?.contents ? value?.contents : ''}`}}>
                        </p>

                    </div>
                    <div className="img-wrap m-b-20">
                        <img src={value?.image} alt=""/>
                    </div>
                </div>
            </ScrollArea>

        </div>
    );

};

export default ModuleNine;
